import { Typography } from "@mui/material";

export default function ListingTypeBadge({ listingType, tags }) {
  return (
    <div style={{ display: "flex" }}>
      <Typography
        sx={{
          color:
            listingType === "Clásica"
              ? "#ffffff"
              : listingType === "Premium"
              ? "#ffffff"
              : listingType === null
              ? "rgba(0, 0, 0, 0.60)"
              : "",
          textAlign: "center",
          fontSize: "11px",
          fontWeight: "500",
          fontFamily: "Montserrat",
          lineHeight: "normal",
          backgroundColor:
            listingType === "Clásica"
              ? "#737373"
              : listingType === "Premium"
              ? "#5873C0"
              : "",
          padding: "4px 8px",
          letterSpacing: "-0.33px",
          borderRadius: "8px",
          width: "fit-content",
        }}
      >
        {listingType === "Clásica"
          ? "Clásica"
          : listingType === "Premium"
          ? "Premium"
          : "N/A"}
      </Typography>

      {tags && Array.isArray(tags) ? (
        tags.includes("lightning_deal") ? (
          <Typography
            sx={{
              color: "white",
              textAlign: "center",
              fontSize: "11px",
              fontWeight: "500",
              fontFamily: "Montserrat",
              lineHeight: "normal",
              backgroundColor: "#ba0095",
              padding: "4px 8px",
              letterSpacing: "-0.33px",
              borderRadius: "8px",
              width: "fit-content",
              marginLeft: "10px",
            }}
          >
            OFERTA RELÁMPAGO
          </Typography>
        ) : tags.includes("deal_of_the_day") ? (
          <Typography
            sx={{
              color: "white",
              textAlign: "center",
              fontSize: "11px",
              fontWeight: "500",
              fontFamily: "Montserrat",
              lineHeight: "normal",
              backgroundColor: "#3483fa",
              padding: "4px 8px",
              letterSpacing: "-0.33px",
              borderRadius: "8px",
              width: "fit-content",
              marginLeft: "10px",
            }}
          >
            OFERTA DEL DÍA
          </Typography>
        ) : null
      ) : null}
    </div>
  );
}
